import React, { useState, useContext, useEffect, useRef } from 'react'
import { dataContext, localestr, uid, toText } from '../utils.js'
import { GEMS_URL } from '../constants'
import UniTable from '../cmp/UniTable'

function AISupplyFill({ actions }) {
    const context = useContext(dataContext)
    const msg = context.msg
    const loaddata=context.loaddata
    const updateData=context.updateData

    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice

    const catGoods = context.data['catGoods'] || []
    const selUnitType = context.data['selUnitType'] || []
    const selGoodType = context.data['selGoodType'] || []
    const selExcise = context.data['selExcise'] || []

    const [invoiceImage, setInvoiceImage] = useState(null)
    const [error, setError] = useState(null)  
    const [isLoading, setIsLoading] = useState(false)
    const [step, setStep] = useState(0) // 0 - вибір зображення, 1 - таблиця UniTable, 2 - створення карток, 3 - успіх
    
    const [invoiceMeta, setInvoiceMeta] = useState({ number: '', date: '', total: 0 })
    const [wndData, setWndData] = useState({ list: [], currentCol: undefined, sorting: { dataId: 'id', sort: 'asc' } })
    const [isActive2, setIsActive2] = useState(false)

    // Стан для другої таблиці (Шаг 2)
    const [step2Data, setStep2Data] = useState({ list: [], currentCol: undefined, sorting: { dataId: 'name', sort: 'asc' } })
    const [isActiveStep2, setIsActiveStep2] = useState(false)

    const fileInputRef = useRef(null);

    // Функція визначення виду акцизу за кодом УКТЗЕД
    const getExciseByUktz = (uktz) => {
        if (!uktz) return '0';
        const code = uktz.toString().trim();
        
        if (code.startsWith('2203')) return '3'; // Пиво
        if (code.startsWith('220820')) return '2'; // Коньяки
        if (code.startsWith('2204') || code.startsWith('2206')) return '2'; // Вина, шампанське, фраголіно
        if (code.startsWith('2208')) return '1'; // Горілка, лікери, джин, ром, віскі
        if (code.startsWith('2402') || code.startsWith('2403')) return '-1'; // Тютюнові вироби
        
        return '0'; // Без акцизу
    }

    // Локальна база товарів Cocktail POS
    const dbProducts = catGoods
        .filter(item => item.marked === '0' && parseInt(item.type) < 2)
        .map(item => ({
            id: item.id,
            name: item.name,
            unit: selUnitType.find(x => x.value === item.unit)?.name || '',
        }))

    // Конфігурація колонок для Шагу 1
    const cols = [
        { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
        { caption: localestr('Назва товару'), minWidth: '110', dataId: 'invoice_name', sortable: true },
        { caption: localestr('Товар в базі'), minWidth: '120', dataId: 'good', sortable: true, typeVal: 'catGoods', setFn: (d) => { setVal('good', d) } },
        { caption: localestr('Од.'), minWidth: '30', maxWidth: '45', dataId: 'unit', sortable: true },
        { caption: localestr('К-сть'), minWidth: '42', maxWidth: '75', dataId: 'sum_qtt', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt', d) } },
        { caption: localestr('Ціна'), minWidth: '80', maxWidth: '100', dataId: 'sum_prc', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_prc', d) } },
        { caption: localestr('Сума'), minWidth: '52', maxWidth: '100', dataId: 'sum_amount', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_amount', d) } },
    ]

    // Конфігурація колонок для Шагу 2 (Без №)
    const colsStep2 = [
        { caption: localestr('Назва'), minWidth: '130', dataId: 'name', sortable: true, typeVal: 'text', setFn: (d) => { setValStep2('name', d) } },
        { caption: localestr('Папка'), minWidth: '80', dataId: 'parent', sortable: true, typeVal: 'fldGoods', setFn: (d) => { setValStep2('parent', d) } },
        { caption: localestr('Вид'), minWidth: '80', dataId: 'type', sortable: true, typeVal: 'selGoodType', setFn: (d) => { setValStep2('type', d) } },
        { caption: localestr('Од.виміру'), minWidth: '80', dataId: 'unit', sortable: true, typeVal: 'selUnitType', setFn: (d) => { setValStep2('unit', d) } },
        { caption: localestr('Вид акцизу'), minWidth: '80', dataId: 'excise', sortable: true, typeVal: 'selExcise', setFn: (d) => { setValStep2('excise', d) } },
        { caption: localestr('УКТЗЕД'), minWidth: '90', dataId: 'uktz', sortable: true, typeVal: 'text', setFn: (d) => { setValStep2('uktz', d) } },
    ]

    const resizeImageToBase64 = (file, maxSide = 1600) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    let width = img.width;
                    let height = img.height;
                    if (width > maxSide || height > maxSide) {
                        if (width > height) {
                            height = Math.round((height * maxSide) / width);
                            width = maxSide;
                        } else {
                            width = Math.round((width * maxSide) / height);
                            height = maxSide;
                        }
                    }
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', 0.85));
                };
                img.onerror = (err) => reject(err);
            };
            reader.onerror = (err) => reject(err);
        });
    }

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setError(localestr('Будь ласка, виберіть файл зображення'));
            return;
        }
        setIsLoading(true); setError(null);
        try {
            const compressedBase64 = await resizeImageToBase64(file, 1600);
            setInvoiceImage(compressedBase64);
        } catch (err) {
            setError(localestr('Помилка при обробці зображення'));
        } finally {
            setIsLoading(false);
        }
    }

    const handle2Step = async () => {
        if (!invoiceImage || !catGoods.length) return;
        setIsLoading(true); setError(null);

        const payload = { image: invoiceImage, db_products: dbProducts }

        fetch(GEMS_URL, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(payload)
        }).then(response => {
            if (response.status !== 200) {
                msg(localestr('Відсутнє з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => {} }])
                setIsLoading(false); return;
            }
            response.text().then(d => {
                const result = JSON.parse(d.substring(1))
                setIsLoading(false)
                
                if (result.status === 'error') {
                    msg(result.msg, localestr('Помилка'), [{ caption: 'OK', action: () => {} }])
                    return;
                }
                
                if (result.items && result.items.length > 0) {
                    setInvoiceMeta({
                        number: result.invoice_number || '',
                        date: result.date || '',
                        total: result.total_amount || 0
                    });

                    const parsedList = result.items.map((item, idx) => {
                        const matchedGood = catGoods.find(g => g.id === item.db_product_id);
                        return {
                            uid: uid(),
                            id: idx + 1,
                            invoice_name: item.invoice_name,
                            good: matchedGood ? { id: matchedGood.id, name: matchedGood.name, obj_type: 'catGoods' } : { id: '', name: '', obj_type: 'catGoods' },
                            unit: matchedGood ? selUnitType.find(x => x.value === matchedGood.unit)?.name : '',
                            sum_qtt: item.quantity,
                            sum_prc: (parseFloat(item.amount) / parseFloat(item.quantity)).toFixed(2),
                            sum_amount: item.amount,
                            uktzed: item.uktzed || '',
                            match_confidence: item.match_confidence,
                            isUserEdited: false
                        }
                    });

                    setWndData({ list: parsedList, currentCol: parsedList[0], sorting: { dataId: 'id', sort: 'asc' } });
                    setStep(1);
                } else {
                    setError(localestr('ІІ не знайшов товарів у накладній.'));
                }
            })
        }).catch(err => {
            setIsLoading(false);
            msg(localestr('Відсутнє з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => {} }]);
        })
    }

    // --- КЕРУВАННЯ ШАГОМ 1 ---
    const setCol = (currentCol) => {
        if (wndData.currentCol && currentCol.uid !== wndData.currentCol.uid) {
            saveValue();
        }
        setIsActive2(true);
        setWndData({ ...wndData, currentCol });
    }

    const setVal = (name, data) => {
        let currentCol = { ...wndData.currentCol };
        currentCol[name] = data;
        
        if (name === 'good' && data && data.id) {
            currentCol.match_confidence = 'high';
        } else if (name === 'good' && (!data || !data.id)) {
            currentCol.match_confidence = 'low';
            currentCol[name] = { id: '', name: '', obj_type: 'catGoods' };
        }

        if (name === 'good' && data) {
            const matchedGood = catGoods.find(g => g.id === data.id);
            if (matchedGood) {
                currentCol.unit = selUnitType.find(x => x.value === matchedGood.unit)?.name || '';
            }
        }
        
        if (name === 'sum_qtt' || name === 'sum_prc') {
            const qtt = parseFloat(name === 'sum_qtt' ? data : currentCol.sum_qtt || 0);
            const prc = parseFloat(name === 'sum_prc' ? data : currentCol.sum_prc || 0);
            currentCol.sum_amount = (qtt * prc).toFixed(2);
        }

        let list = wndData.list.map(el => el.uid === currentCol.uid ? currentCol : el);
        setWndData({ ...wndData, list, currentCol });
    }

    const saveValue = (act = null) => {
        setIsActive2(false);
        if (wndData.currentCol) {
            let updatedCol = { ...wndData.currentCol, isUserEdited: false };
            let list = wndData.list.map(el => el.uid === updatedCol.uid ? updatedCol : el);
            setWndData({ ...wndData, list, currentCol: updatedCol });
        }
        if (act && typeof act === 'function') act();
    }

    const cancelEdit = () => {
        setIsActive2(false);
    }

    const sortList = (col, sort) => {
        let list = [...wndData.list];
        list.sort((a, b) => {
            let vala = toText(a[col]).toLowerCase();
            let valb = toText(b[col]).toLowerCase();
            if (sort === 'asc') return vala < valb ? -1 : vala > valb ? 1 : 0;
            return vala < valb ? 1 : vala > valb ? -1 : 0;
        });
        setWndData({ ...wndData, list, sorting: { dataId: col, sort } });
    }

    // --- КЕРУВАННЯ ШАГОМ 2 ---
    const setColStep2 = (currentCol) => {
        if (step2Data.currentCol && currentCol.uid !== step2Data.currentCol.uid) {
            saveValueStep2();
        }
        setIsActiveStep2(true);
        setStep2Data({ ...step2Data, currentCol });
    }

    const setValStep2 = (name, data) => {
        let currentCol = { ...step2Data.currentCol };
        
        if (name === 'parent') {
            currentCol.parent = {...data};
        } else if (name === 'type') {
            currentCol.type = selGoodType.find(x => x.value === data) || { value: '1', name: localestr('Товар') };
        } else if (name === 'unit') {
            currentCol.unit = selUnitType.find(x => x.value === data) || { value: '1', name: localestr('шт') };
        } else if (name === 'excise') {
            currentCol.excise = selExcise.find(x => x.value === data) || { value: '0', name: localestr('Без акзицу') };
        } else {
            currentCol[name] = data;
        }

        if (name === 'uktz' && data) {
            const calculatedExciseValue = getExciseByUktz(data);
            const foundExcise = selExcise.find(x => x.value === calculatedExciseValue);
            currentCol.excise = foundExcise ? foundExcise : { value: calculatedExciseValue };
        }

        let list = step2Data.list.map(el => el.uid === currentCol.uid ? currentCol : el);
        setStep2Data({ ...step2Data, list, currentCol });
    }

    const saveValueStep2 = (act = null) => {
        setIsActiveStep2(false);
        if (step2Data.currentCol) {
            let list = step2Data.list.map(el => el.uid === step2Data.currentCol.uid ? step2Data.currentCol : el);
            setStep2Data({ ...step2Data, list, currentCol: undefined });
        }
        if (act === -1) return
        else if (act) setTimeout(() => { act() }, 200)
    }

    const sortListStep2 = (col, sort) => {
        let list = [...step2Data.list];
        list.sort((a, b) => {
            let vala = toText(a[col]).toLowerCase();
            let valb = toText(b[col]).toLowerCase();
            if (sort === 'asc') return vala < valb ? -1 : vala > valb ? 1 : 0;
            return vala < valb ? 1 : vala > valb ? -1 : 0;
        });
        setStep2Data({ ...step2Data, list, sorting: { dataId: col, sort } });
    }

    const handleNextStep = () => {
        const unmapped = wndData.list.filter(item => !item.good || !item.good.id);
        if (unmapped.length > 0) {
            const step2Prepared = unmapped.map((item) => {
                const matchedUnitObj = selUnitType.find(u => u.name.toLowerCase() === item.unit.toLowerCase()) || { value: '1', name: localestr('шт') };
                const initialExciseValue = getExciseByUktz(item.uktzed);
                const matchedExciseObj = selExcise.find(x => x.value === initialExciseValue) || { value: '0', name: localestr('Без акзицу') };
                const defaultTypeObj = selGoodType[1] || { value: '1', name: localestr('Товар') };

                return {
                    uid: item.uid,
                    name: item.invoice_name,
                    parent: { id: '', name: '' },      
                    type: defaultTypeObj,          
                    unit: matchedUnitObj,   
                    excise: matchedExciseObj, 
                    uktz: item.uktzed || ''        
                }
            });

            setStep2Data({ list: step2Prepared, currentCol: step2Prepared[0], sorting: { dataId: 'name', sort: 'asc' } });
            setStep(2); 
        } else {
            handleFinalize(); 
        }
    }

    const handleFinalize = (dontSave = false) => {
        if (isActiveStep2 && !dontSave) {
            saveValueStep2(() => { handleFinalize(true) })
            return
        }
        if(step2Data.list.length > 0) {
            //зберегти, оновити дані і вставити ід у масив
            const send_to=step2Data.list.map(el=>({
                uid:el.uid,
                name:el.name.substring(0,70),
                parent:el.parent,
                type:el.type?.value || 1,
                unit:el.unit?.value || 1,
                excise:el.excise?.value || 1,
                uktz:el.uktz.substring(0,12)
            }))
            loaddata('action=adgGoods&data='+JSON.stringify(send_to),undefined,updateGoods)
        } else {
            //одразу заповнення
            fillDoc(wndData.list)
        }
        //console.log("Дані накладної збережено:", invoiceMeta, wndData.list, step2Data.list);
        //setStep(3);
    }

    const updateGoods=d=>{
        const status=d.status
        if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
        if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
        updateData(d.key)
        const fillData=wndData.list.map(el=>{
            const it={...el}
            const idx=d.data.findIndex(it=>it.uid===el.uid)
            if(idx!==-1) {it.good.id=d.data[idx].id;it.good.name=d.data[idx].name;it.good.unit=d.data[idx].unit;}
            return it
        })
        setTimeout(()=>fillDoc(fillData),300)
    }

    const fillDoc = arrData => {
        for(let i=0; i<arrData.length;i++){
            const good=catGoods.find(el=>el.id===arrData[i].good.id)
            const data=[3,(good||arrData[i].good), parseFloat(arrData[i].sum_qtt), parseFloat(arrData[i].sum_prc), undefined, parseFloat(arrData[i].sum_amount)]
            tabChoice(data)
        }
        tabChoice([1,'in_num',invoiceMeta.number])
        //tabChoice([2,'in_date',invoiceMeta.date])
        tabClose()
    }

    // Підготовка списку Шагу 1
    const wndDataList = wndData.list.map(el => {
        const item = { ...el };
        if (!item.isUserEdited) {
            if (!item.good || !item.good.id) {
                item.colour = '#ffcccc';
            } else if (item.match_confidence === 'medium') {
                item.colour = '#fff3cd';
            } else {
                item.colour = '';
            }
        }
        return item;
    });

    useEffect(() => {
        if (context.data['catGoods'] === undefined) context.getData('catGoods')
    }, [context])

    // --- ШАГ 0: Вибір зображення ---
    if (step === 0) return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box', width: '100%' }}>
            <input type="file" accept="image/*" onChange={handleFileChange} ref={fileInputRef} style={{ display: 'none' }} disabled={isLoading} />
            
            {/* Інструкція зникає, якщо картинку вже вибрано */}
            {!invoiceImage && (
                <div style={{ padding: '12px', borderRadius: '6px', marginBottom: '10px', width: '100%', boxSizing: 'border-box' }}>
                    <p style={{ margin: 0, fontSize: '14px', color: '#334e68', lineHeight: '1.4' }}>
                        <strong>{localestr('Інструкція:')}</strong>{' '} {localestr('Натисніть кнопку нижче та виберіть фото або скан-копію накладної для розпізнавання')}
                    </p>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, width: '100%', minHeight: '0', marginBottom: '10px', boxSizing: 'border-box' }}>
                {!invoiceImage ? (
                    <div style={{ width: '230px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => !isLoading && fileInputRef.current.click()}>
                        <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{localestr('Вибрати картинку накладної')}</div>
                    </div>
                ) : (
                    <div onClick={() => !isLoading && fileInputRef.current.click()} style={{padding: '4px', width: '100%', height: '100%',cursor: isLoading ? 'not-allowed' : 'pointer', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                        <img src={invoiceImage} alt="Прев'ю" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block' }} />
                    </div>
                )}
            </div>

            {error && <div style={{ color: '#dc3545', fontSize: '14px', textAlign: 'center', fontWeight: '500', marginBottom: '10px' }}>⚠️ {error}</div>}

            {invoiceImage && (
                <div style={{ textAlign: 'center', marginTop: 'auto', padding: '5px', width: '100%', boxSizing: 'border-box' }}>
                    <div style={{ width: '140px', display: 'inline-block', verticalAlign: 'bottom', opacity: isLoading ? 0.6 : 1, pointerEvents: isLoading ? 'none' : 'auto' }} className={'key_btn'} onClick={handle2Step}>
                        <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{isLoading ? localestr('Обробка...') : localestr('Далі')}</div>
                    </div>
                </div>
            )}
        </div>
    )

    // --- ШАГ 1: Верифікація через UniTable ---
    if (step === 1) return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box', padding: '3px', width: '100%' }}>
            <div style={{ display: 'flex', gap: '20px', backgroundColor: '#f8f9fa', padding: '8px', borderRadius: '4px', fontSize: '13px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}>
                <div><strong>{localestr('Накладна №:')}</strong> {invoiceMeta.number}</div>
                <div><strong>{localestr('Дата:')}</strong> {invoiceMeta.date}</div>
                <div style={{ marginLeft: 'auto' }}><strong>{localestr('Сума:')}</strong> <span style={{ color: '#2e59d9', fontWeight: 'bold' }}>{invoiceMeta.total} грн</span></div>
            </div>

            <div style={{ margin: '6px 0', padding: '6px 10px', backgroundColor: '#fdfffe', borderLeft: '3px solid #007bff', fontSize: '12px', color: '#555', boxSizing: 'border-box', borderRadius: '0 4px 4px 0' }}>
                💡 <span style={{ backgroundColor: '#fff3cd', padding: '1px 4px', borderRadius: '3px', fontWeight: '500' }}>{localestr('Жовті рядки')}</span> {localestr('потрібно перевірити')} | <span style={{ backgroundColor: '#ffcccc', padding: '1px 4px', borderRadius: '3px', fontWeight: '500' }}>{localestr('Червоні рядки')}</span> {localestr('автоматично створять новий товар у базі.')}
            </div>

            {/* Додано overflow: hidden, щоб не з'являвся другий зовнішній скролл */}
            <div style={{ flex: 1, minHeight: 0, border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                <UniTable 
                    haveHeader={true} 
                    colsArr={cols} 
                    data={wndDataList} 
                    currCol={{ ...wndData.currentCol, edit: isActive2 }} 
                    sorting={wndData.sorting} 
                    clickSort={sortList} 
                    clickHandle={setCol} 
                    saveHandle={saveValue} 
                    cancelHandle={cancelEdit} 
                    needFocus={() => -1} 
                    tblPos={() => {}}
                />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', padding: '5px 0', width: '100%', boxSizing: 'border-box' }}>
                <div style={{ width: '100px', display: 'inline-block' }} className={'key_btn'} onClick={() => setStep(0)}>
                    <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{localestr('Назад')}</div>
                </div>
                <div style={{ width: '140px', display: 'inline-block' }} className={'key_btn'} onClick={handleNextStep}>
                    <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{localestr('Далі')}</div>
                </div>
            </div>
        </div>
    )

    // --- ШАГ 2: Створення нових карток товарів через UniTable ---
    if (step === 2) return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box', padding: '3px', width: '100%' }}>
            <div style={{ backgroundColor: '#fff5f5', padding: '8px', borderRadius: '4px', fontSize: '13px', border: '1px solid #ffcdd2', width: '100%', boxSizing: 'border-box', marginBottom: '8px' }}>
                <strong style={{ color: '#c62828' }}>{localestr('Створення нових товарів:')}</strong> {localestr('Заповніть або відредагуйте реквізити для нових товарів перед збереженням.')}
            </div>

            {/* Додано overflow: hidden, щоб уникнути подвійного скролу під таблицею */}
            <div style={{ flex: 1, minHeight: 0, border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                <UniTable 
                    haveHeader={true} 
                    colsArr={colsStep2} 
                    data={step2Data.list} 
                    currCol={{ ...step2Data.currentCol, edit: isActiveStep2 }} 
                    sorting={step2Data.sorting} 
                    clickSort={sortListStep2} 
                    clickHandle={setColStep2} 
                    saveHandle={saveValueStep2} 
                    cancelHandle={() => setIsActiveStep2(false)} 
                    needFocus={() => -1} 
                    tblPos={() => {}}
                />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', padding: '5px 0', width: '100%', boxSizing: 'border-box' }}>
                <div style={{ width: '100px', display: 'inline-block' }} className={'key_btn'} onClick={() => setStep(1)}>
                    <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{localestr('Назад')}</div>
                </div>
                <div style={{ width: '160px', display: 'inline-block' }} className={'key_btn'} onClick={handleFinalize}>
                    <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{localestr('Створити товари')}</div>
                </div>
            </div>
        </div>
    )

    // --- ШАГ 3: Фінал ---
    return (
        <div style={{ padding: '30px', textAlign: 'center', width: '100%', boxSizing: 'border-box' }}>
            <h3>✔️ {localestr('Документ успішно створено!')}</h3>
            <div style={{ width: '120px', display: 'inline-block', marginTop: '15px' }} className={'key_btn'} onClick={() => setStep(0)}>
                <div style={{ height: '30px', lineHeight: '30px', display: 'block', textAlign: 'center' }}>{localestr('Спочатку')}</div>
            </div>
        </div>
    )
}

export default AISupplyFill